import { Flex } from '@chakra-ui/react';
import { FilterIcon } from 'ui-components/dist/FilterIcon';
import { AddTalentButton } from '~/components/ManagerTopBar/components/AddTalentButton';
import { FEATURE_FLAGS } from '~/constants';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import { ClearAllFiltersButton } from '~/screens/MyAgency/components/ClearAllFiltersButton';
import { SearchTalent } from '~/screens/MyAgency/components/SearchTalent';
import { SortCreatorsDropDown } from '~/screens/MyAgency/components/SortCreatorsDropdown';
import { AgencyHeaderButton } from '~/screens/MyAgency/components/Table/AgencyHeaderButton';
import { ToggleView } from '~/screens/MyAgency/components/ToggleView';
import {
  useAdvancedFiltersStore,
  useCreatorsFiltersStore,
} from '~/screens/MyAgency/store';
import { allowedSortDirections, allowedSortFields } from '~/searchApi';
import { ICreator } from '~/types';

import { TalentPageFilterToggle } from '../TalentPageFiltersDrawer/TalentPageFilterToggle';
import { Header } from './Header';
import { ShareRosterListBtn } from './ShareRosterListBtn';

interface Props {
  agencyData: ICreator[];
  displaySaveListButton: boolean;
  onAudienceClick: () => void;
  onTalentClick: () => void;
  onClearAllFilters: () => void;
  isAgencyEnabled?: boolean;
  isAudienceFiltersEnabled?: boolean;
  isShared?: boolean;
  isTalentFiltersEnabled?: boolean;
  isTalentSearchEnabled?: boolean;
  setSortingOrder: (
    field: allowedSortFields,
    direction: allowedSortDirections,
  ) => void;
  sortDirection: allowedSortDirections;
  sortField: allowedSortFields;
  logo: string;
  title: string;
  totalCreators: number;
}

export const HeaderViewMd: React.FC<Props> = ({
  displaySaveListButton,
  onAudienceClick,
  onTalentClick,
  onClearAllFilters,
  isAgencyEnabled,
  isAudienceFiltersEnabled,
  isShared = false,
  isTalentFiltersEnabled,
  isTalentSearchEnabled,
  setSortingOrder,
  sortDirection,
  sortField,
  logo,
  title,
}) => {
  const { appliedFilters } = useAdvancedFiltersStore();
  const { appliedFilters: appliedCreatorFilters } = useCreatorsFiltersStore();
  const foamAddTalent = useFeatureFlag(FEATURE_FLAGS.foamAddTalent);
  const globalTalentFiltersFeature = useFeature(
    FEATURE_FLAGS.foamTalentGlobalFilters,
  );

  return (
    <Flex direction="column" gap={2} marginBottom={2} paddingTop="spacing-200">
      <Flex justifyContent="space-between" flexWrap="wrap">
        <Flex>
          <Header logo={logo} title={title} isAgencyEnabled={isAgencyEnabled} />
        </Flex>
      </Flex>
      <Flex gap={2} flexWrap="wrap">
        {isTalentSearchEnabled && (
          <SearchTalent
            inputGroupProps={{
              marginY: 0,
              flex: '1 1 auto',
            }}
          />
        )}
        <SortCreatorsDropDown
          sortField={sortField}
          sortDirection={sortDirection}
          setSortingOrder={setSortingOrder}
        />
        {globalTalentFiltersFeature.isEnabled && <TalentPageFilterToggle />}
        {!globalTalentFiltersFeature.isEnabled && isTalentFiltersEnabled && (
          <AgencyHeaderButton
            onClick={onTalentClick}
            icon={FilterIcon}
            title="Talent"
            aria-label="Talent Filter"
            iconOnly={true}
            iconProps={{ boxSize: 4 }}
            track-id="foam-myagency-talent-filters"
          />
        )}
        {!globalTalentFiltersFeature.isEnabled && isAudienceFiltersEnabled && (
          <AgencyHeaderButton
            onClick={onAudienceClick}
            icon={FilterIcon}
            title="Audience"
            aria-label="Audience Filters"
            iconOnly={true}
            iconProps={{ boxSize: 4 }}
          />
        )}

        <ToggleView radioGroupProps={{ marginBottom: 0 }} />
        {!displaySaveListButton && foamAddTalent === 'enabled' && (
          <AddTalentButton />
        )}
        {!isShared && <ShareRosterListBtn />}
      </Flex>

      <Flex flexWrap="wrap">
        {(appliedFilters.length > 0 || appliedCreatorFilters.length > 0) &&
          isAudienceFiltersEnabled && (
            <ClearAllFiltersButton onClear={onClearAllFilters} />
          )}
      </Flex>
    </Flex>
  );
};
